module.exports = __webpack_public_path__ + "img/greenhouse.48dca312.svg";